var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-avatar-letter__wrapper"},[_c('div',{class:['k-avatar-letter__label', {'c-pointer k-avatar-letter__editing': _vm.isEditing}]},[(_vm.avatar)?_c('img',{staticClass:"k-avatar-letter__img",attrs:{"src":_vm.avatar,"alt":"avatar"}}):_c('div',{staticClass:"k-avatar-letter__letter",style:({
                width: (_vm.size + "px "),
                height: (_vm.size + "px "),
                'font-size': ((_vm.size - 16) + "px"),
                'line-height': (_vm.size + "px")
            })},[_vm._v(_vm._s(_vm.avatarLetter))]),_vm._t("default"),_vm._t("edit")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }